import { BroadcastEventType } from '@cotera/api';
import { emit } from './broadcast-event-bus';

/**
 * Broadcasts a tool-credential-updated event on the local event bus after a
 * tool provider credential is added, deleted, or a provider is
 * (dis)connected.
 *
 * Watchables created via `WatchablesFactory.makeToolCredentialUpdatedWatchable`
 * (and the query-sync watchable mounted in {@link CocoBroadcastQuerySyncModel})
 * listen for this and refresh the org's tool caches, propagating into hooks
 * that read tool data such as `useToolsAsync` / `useCocoMentions`.
 *
 * @param orgId    org whose tool credentials changed
 * @param provider optional provider key whose credentials changed
 */
export function emitToolCredentialUpdated(
  orgId: string,
  provider?: string
): void {
  emit(BroadcastEventType.ToolCredentialUpdated, { orgId, provider });
}
